import React from 'react';
import AppColors from '../../common/Colors';
import SessionStateManager from "../../common/SessionStateManager";
import TTLProxy from "../../common/TTLAsyncProxy";
import NavigationHelper from "../../common/NavigationHelper";
import {Line} from "rc-progress";
import {Button} from "reactstrap";
import './Register.css';
import {AuthEndpoints, UsersEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import PlatformRender from "../../components/PlatformRender/PlatformRender";
import {DevicePlatforms} from "../../common/Constants";
import MDSpinner from 'react-md-spinner';
import MDProgress from 'react-md-progress-bar';
import LogoHeader from "../../components/LogoHeader/LogoHeader";
import PropTypes from 'prop-types';

//  The color for the progress bar
const ProgressColor = '#28b416';

//
const ValidationStatus = {
    Failed : 'failed',
    Succeeded :  'passed'
};

const RegisterButton = (props) => {
    return <Button type="submit" color="green" disabled={props.disabled} block> <i className="icon-user"></i>{props.text}</Button>
};

const HeadView = (props) => {

    return (<div>
                <h2 className="text-left">{props.title}</h2>
                <div className="clearfix">

                            <div className="pull-left">
                                <p className="text-muted">{props.message}</p>
                            </div>

                            <div className="pull-right">
                                <b style={{fontSize: 'smaller'}}>{props.info}</b>
                            </div>
                </div>
                <hr style={{marginTop: '-5px'}}/>
            </div>);

};

const LoadingBars = (props) => {
    return  <MDProgress overlay={false} show={true}/>;
};

const BusyContent = (props) => {
    return (<div className="text-center animated fadeIn" >
        <div style={{padding: 40}}>
            <h5>{props.title}</h5>
            <MDSpinner size={55}/>
        </div>
        <p>{props.message}</p>
    </div>);

};

const ErrorDisplay = (props) => {
    return  props.error ? <div className="alert-danger alert-dismissable">
        {(Array.isArray(props.error) ?
                <ul style={{paddingTop : 5, paddingBottom: 5}}>
                    {props.error.map((x,i) => <li key={i} className="error-label-list">{x}</li>)}
                </ul>: <p className="error-label" style={{padding: '10px'}}>{props.error}</p>
        )}
    </div> : null;
};

ErrorDisplay.propTypes= {
    error: PropTypes.any
};


const Progress = (props) => {
    return <div style={{marginBottom: '10px'}}> <Line percent={ Math.min( props.active / props.max , 1) * 100 } strokeWidth="1" strokeColor={props.color || ProgressColor}/> </div>;
};

class RegisterComponent extends React.Component{

    constructor(props,name){
        super(props);

        const session = new SessionStateManager(name,true);
        this.session = session;

        this.state = {
            name: name,
            isBusy: false,
            stateError: null
        };

        //  keep proxy reference
        this.proxy = TTLProxy.getInstance();

        //  called to complete process
        this.onComplete = this.onComplete.bind(this);

        //  switches to the next state
        this.moveNextPhase = this.moveNextPhase.bind(this);

        //  reset
        this.reset = this.reset.bind(this);

        //  move back
        this.movePreviousPhase = this.movePreviousPhase.bind(this);

        //  the state info
        this._stateInfo = session.getState('stateInfo',{});

        //  keep background color
        this._bodyColor = window.document.body.style.backgroundColor;
    }

    /**
     * Get proxy instance
     * @returns {*}
     */
    getProxy(){
        return this.proxy;
    }

    componentDidMount(){

        const me = this;
        window.addEventListener("beforeunload", () => {

            if(!me.isComplete){
                me.saveState();
            }

        });

    }

    componentWillUnmount(){
        this.saveState();
    }


    /**
     * Saves the current registration state
     */
    saveState() {

        this.session.putStateFrame({
            stateInfo: this._stateInfo,
            activePhase: this.getCurrentPhase()
        }).save();

    }

    /**
     * Save state
     * @param key
     * @param value
     */
    persistState(key,value){
        let stateInfo = this._stateInfo;
        stateInfo[key] = value;

        //  save state immediately
        this.saveState();
    }

    /**
     * Retrieve the value for the key
     * @param key
     */
    getStateValue(key){
        return this._stateInfo[key];
    }

    /**
     * Sets info about various phases
     * @param phaseInfo
     */
    setPhaseInfo(phaseInfo){
        this.phases = phaseInfo;
    }

    /**
     * Sets current error
     * @param error
     */
    setError(error){

        this.setState({
            stateError: error
        });

    }

    /**
     * Clears the current error
     */
    clearError(){

        this.setState({
            stateError: null
        });

    }

    getWizard(){
        return this._wizard;
    }

    async moveNextPhase(evt){

        const me = this;

        if(evt === false){
            return this.getWizard().moveNextPhase();
        }

        if(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }

        //
        let phaseInfo = this.getPhaseInfo();

        //  validate form first
        const form = phaseInfo.getForm ?  phaseInfo.getForm() : null;

        //
        if(form) {

            //  legacy validation library
            if(form.hasOwnProperty('validateAll')) {
                let vData = form.validateAll();
                if (Object.keys(vData).length > 0) {
                    return;
                }
            }

            //
            if(form.hasOwnProperty('validateForm')) {
                const errors = await form.validateForm();
                if (Object.keys(errors).length > 0) {
                    return;
                }
            }

        }

        this.setState({
            isBusy: true,
            stateError: null
        });

        let _moveNext = true;
        if(phaseInfo.hasOwnProperty('validate')){

            try {
                _moveNext = await phaseInfo.validate();
            }
            catch (e) {
                //  An exception occurred while validating
            }

        }

        if(_moveNext) {

            //  clear error when moving to next state
            me.clearError();

            //  move to next phase
            me.getWizard().moveNextPhase();
        }

        this.setState({
            isBusy: false
        });

    }

    movePreviousPhase(){

        this.setState({
            stateError: null
        });

        //
        this.getWizard().movePreviousPhase();
    }

    getCurrentPhase(){

        const wizard = this.getWizard();
        if(wizard){
            return wizard.getActivePhase();
        }

        return 0;
    }

    /**
     * Process validation for registration
     * @param endpoint The validation endpoint
     */
    processValidation(endpoint){

        const me = this;
        return this.proxy.processRequest(endpoint).then(response => {

            const body = response.body;
            switch (body.verify_status){
                case ValidationStatus.Failed:{

                    let msg = body.message;
                    if(body.fields.length > 0) {
                        msg = body.fields.map(x => x.message);
                    }

                    me.setError(msg);

                    return false;
                }
            }

            return true;

        }).catch((err) => {

            //  Set error
            me.setError(Utils.getResponseError(err));

            //
            return false;
        });

    }


    /***
     * Register the account
     * @returns {Promise.<TResult>}
     */
    processRegister(endpoint){

        const me = this;
        return this.proxy.processRequest(endpoint).then(async response =>{

            if(response.ok){
                me.persistState('user',response.body);
                await me.moveNextPhase();
                return true;
            }

            //  go back to previous page
            me.movePreviousPhase();

            return false;

        }).catch(err => {

            //
            me.setState({
                stateError: Utils.getResponseError(err)
            });

            // go back to previous page
            me.movePreviousPhase();
        });

    }

    /**
     * Activates a user account given required parameters
     * @param token The token issued to the client
     * @param username The username of the user. This will be used to fetch the user's identity
     * @param password The password of the user. This will be used to fetch the user's identity
     */
    processAccountActivation(token , username, password ){

        const me = this;
        const proxy = this.getProxy();
        return proxy.processRequest(AuthEndpoints.login(username,password)).then((response) =>{

            //  clear session
            window.sessionStorage.clear();

            //  login was successful
            //  just in case
            NavigationHelper.navigate('/login',{ tip: 'Account already activated. To begin, enter credentials.' })

        }).catch(err => {

            //  unauthorized??
            if(err.response.status == 401){

                //  get token from response

                const body = err.response.body;
                const identity = body.error.detail.identity;

                return proxy.processRequest(UsersEndpoints.activateAccount(token,identity)).then((res) =>{

                    //  was successful??
                    if(res.ok) {
                        me.onComplete();
                    }

                });

            }


            return Promise.reject(err);

        }).catch(err =>{
            me.setError( Utils.getResponseError(err));
            return false;
        });

    }

    getPhaseInfo(){

        const phase = this.getCurrentPhase();
        for(let item in this.phases){

            if(this.phases[item].index === phase){
                return this.phases[item];
            }

        }
    }

    /**
     * Called when react wizard complete is fired. We usually navigate to
     */
    onComplete(){

        this.isComplete = true;

        //  clear session state
        this.session.reset();

        //  redirect user to login
        NavigationHelper.navigate('/login' , {
            tip: 'Account activated successfully. To begin, enter your credentials.'
        });

    }

    /**
     * Render the current state error
     */
    renderCurrentError(){
        return <ErrorDisplay error={this.state.stateError}/>
    }

    /**
     * Resets the current phase to zero
     */
    reset(){

        //  clear errors
        this.setState({
            stateError: null
        });

        //  reset all form values
        const phaseInfo = this.phases;
        if(phaseInfo){

            for(let item in phaseInfo){

                if(phaseInfo.hasOwnProperty(item)) {
                    const frame = phaseInfo[item];
                    const form = frame.getForm ? frame.getForm() : null;
                    if (form) {
                        form.resetForm();
                    }
                }
            }
        }

        //
        this.getWizard().reset();
    }

    /**
     * Renders the content for registration.
     */
    wizardRender(){

        // TODO: Place render code here...

    }

    render(){

       return <div>

           <PlatformRender platform={DevicePlatforms.Desktop}>
               <div className="app flex-row align-items-center" style={{backgroundColor: AppColors.PageBackgroundColor }}>
                   <div className="container">
                       <div className="row justify-content-center">
                           <div className="col-md-6">
                               <div className="card mx-5 register-form" style={{ minWidth: 444 }} >
                                   <LogoHeader style={{padding: 17 , paddingBottom: 0}}/>
                                   {this.wizardRender()}
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </PlatformRender>

           <PlatformRender platform={DevicePlatforms.Mobile} onActivate={() => { window.document.body.style.backgroundColor = AppColors.PageWhiteBgColor }} onDeactivate={() => { window.document.body.style.backgroundColor = this._bodyColor }}>
                   <div style={{ width: '100%' }}>
                       <LogoHeader style={{padding: 17 , paddingBottom: 0}}/>
                       {this.wizardRender()}
                   </div>
           </PlatformRender>

        </div>;
    }
}

export {
    RegisterComponent,
    HeadView,
    Progress,
    ErrorDisplay,
    RegisterButton,
    BusyContent,
    LoadingBars
};


// WEBPACK FOOTER //
// ./src/views/Register/RegisterBase.js